import { Link } from "react-router-dom";
import { Linkedin, MessageCircle, ArrowUpRight } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="site-footer"
      className="border-t border-zinc-200 bg-zinc-950 text-zinc-200"
    >
      <div className="mx-auto max-w-[1400px] px-6 pt-20 pb-10 md:px-12 lg:px-16">
        <div className="grid grid-cols-1 gap-12 md:grid-cols-12">
          <div className="md:col-span-4">
            <div className="flex items-center gap-3">
              <div className="flex h-10 w-10 items-center justify-center bg-white text-zinc-950">
                <span className="font-heading text-[17px] font-black leading-none">
                  A
                </span>
              </div>
              <div className="leading-none">
                <div className="font-heading text-base font-bold text-white">
                  Agrim Ventures
                </div>
                <div className="font-mono-plex text-[10px] uppercase tracking-[0.22em] text-zinc-500">
                  Private Limited
                </div>
              </div>
            </div>
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-zinc-400">
              Trading, import, and distribution of PET resin with a commitment
              to social impact through skilling.
            </p>
            <div className="mt-8 flex items-center gap-3">
              <a
                href="https://www.linkedin.com"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-linkedin"
                aria-label="LinkedIn"
                className="flex h-10 w-10 items-center justify-center border border-zinc-700 text-zinc-300 transition-colors hover:border-white hover:text-white"
              >
                <Linkedin className="h-4 w-4" />
              </a>
              <a
                href="https://wa.me/919999999999"
                target="_blank"
                rel="noreferrer"
                data-testid="footer-whatsapp"
                aria-label="WhatsApp"
                className="flex h-10 w-10 items-center justify-center border border-zinc-700 text-zinc-300 transition-colors hover:border-white hover:text-white"
              >
                <MessageCircle className="h-4 w-4" />
              </a>
            </div>
          </div>

          <div className="md:col-span-3">
            <div className="font-mono-plex text-[10px] uppercase tracking-[0.22em] text-zinc-500">
              Navigate
            </div>
            <ul className="mt-6 space-y-3">
              {[
                { to: "/", label: "Home" },
                { to: "/about", label: "About Us" },
                { to: "/our-business", label: "Our Business" },
                { to: "/contact", label: "Contact Us" },
              ].map((l) => (
                <li key={l.to}>
                  <Link
                    to={l.to}
                    data-testid={`footer-link-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                    className="group inline-flex items-center gap-2 text-sm text-zinc-300 transition-colors hover:text-white"
                  >
                    <span>{l.label}</span>
                    <ArrowUpRight className="h-3 w-3 -translate-y-[1px] opacity-0 transition-opacity group-hover:opacity-100" />
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-5">
            <div className="font-mono-plex text-[10px] uppercase tracking-[0.22em] text-zinc-500">
              Contact
            </div>
            <div className="mt-6 space-y-4 text-sm text-zinc-300">
              <div>
                <div className="font-mono-plex text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                  Registered Office
                </div>
                <p className="mt-1 text-zinc-300">
                  Agrim Ventures Private Limited
                  <br />
                  A2-Ashok Nagar, Udaipur
                  <br />
                  Rajasthan (India) - Pin 313001
                  <br />
                  <span className="mt-2 inline-block font-mono-plex text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                    CIN: U74999RJ2022PTC080381
                  </span>
                </p>
              </div>
              <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
                <div>
                  <div className="font-mono-plex text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                    Email
                  </div>
                  <a
                    href="mailto:info@agrimventures.co.in"
                    data-testid="footer-email"
                    className="mt-1 block text-zinc-200 hover:text-white"
                  >
                    info@agrimventures.co.in
                  </a>
                </div>
                <div>
                  <div className="font-mono-plex text-[10px] uppercase tracking-[0.18em] text-zinc-500">
                    Phone
                  </div>
                  <a
                    href="tel:+912942941033"
                    data-testid="footer-phone"
                    className="mt-1 block text-zinc-200 hover:text-white"
                  >
                    0294-2941033
                  </a>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="mt-16 flex flex-col items-start justify-between gap-4 border-t border-zinc-800 pt-8 md:flex-row md:items-center">
          <div className="font-mono-plex text-[11px] uppercase tracking-[0.18em] text-zinc-500">
            © 2026 Agrim Ventures Private Limited. All Rights Reserved.
          </div>
          <div className="font-mono-plex text-[11px] uppercase tracking-[0.18em] text-zinc-500">
            Wide Distribution Network
          </div>
        </div>
      </div>
    </footer>
  );
}
